import { db } from "./firebase";

import {
    collection,
    getDocs,
    query,
    where,
    setDoc,
    doc,
    getDoc,
    serverTimestamp,
    limit
} from "firebase/firestore";

/* ===============================
   FORMAT DATE
================================ */

const formatDate = (timestamp) => {

    if (!timestamp) return "";

    return timestamp.toDate().toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric"
    });

};

/* ===============================
   GET ALL BLOGS
================================ */

export const getAllBlogs = async () => {

    const q = query(
        collection(db, "blogs"),
        where("published", "==", true)
    );

    const snapshot = await getDocs(q);

    return snapshot.docs.map(docSnap => ({

        id: docSnap.id,

        ...docSnap.data(),

        date: formatDate(docSnap.data().publishDate),

        readTime: `${docSnap.data().readTime} min read`

    }));

};

/* ===============================
   GET FEATURED BLOG
================================ */

export const getFeaturedBlog = async () => {

    const q = query(
        collection(db, "blogs"),
        where("featured", "==", true),
        where("published", "==", true),
        limit(1)
    );

    const snapshot = await getDocs(q);

    if (snapshot.empty) return null;

    const data = snapshot.docs[0].data();

    return {

        id: snapshot.docs[0].id,

        ...data,

        date: formatDate(data.publishDate),

        readTime: `${data.readTime} min read`

    };

};

/* ===============================
   CREATE BLOG
================================ */

export const createBlog = async (blog) => {

    await setDoc(

        doc(db, "blogs", blog.slug),

        {

            ...blog,

            publishDate: serverTimestamp(),

            createdAt: serverTimestamp(),

            updatedAt: serverTimestamp()

        }

    );

};

/* ===============================
   GET BLOG BY SLUG
================================ */

export const getBlogBySlug = async (slug) => {

    const blogRef = doc(db, "blogs", slug);

    const snapshot = await getDoc(blogRef);

    if (!snapshot.exists()) {
        return null;
    }

    const data = snapshot.data();

    return {

        id: snapshot.id,

        ...data,

        date: formatDate(data.publishDate),

        readTime: `${data.readTime} min read`

    };

};